import { useAccount, useIsAuthenticated, useMsal } from '@azure/msal-react';
import { DefaultButton, Spinner, SpinnerSize } from '@fluentui/react';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import './index.scss'
import { useStore } from "../../store/app";
import NavigationBar from "./subComponents/navigationBar";
import CallbackLoggedInNotKnow from "./subComponents/callbackLoggedInNotKnow";
import { useZod } from "../../services/api/ApiClient";

// Process callback from AAD to check whether or not we know the tenant.

const Callback = () => {
    const {zodiosHooks} = useZod();
    const history = useHistory();
    // Get the return URL from the query string
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const returnUrl = urlParams.get('returnUrl') ?? '/';

    const known = useStore((state) => state.me.known);
    const {isLoading: meLoading, isError: meError, error: err} = zodiosHooks.useGetApiabpMeaannemer();

    const {accounts, inProgress} = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const account = useAccount(accounts[0]);

    const {instance} = useMsal();

    const [loginProgrees, setLoginProgrees] = useState(false);

    useEffect(() => {
        if (
            inProgress.toString() === 'none' &&
            account &&
            isAuthenticated &&
            !meLoading &&
            !meError
        ) {
            useStore.setState({me: {known: true}})
        }
        console.log(err);
    }, [inProgress, account, meLoading, isAuthenticated]);

    useEffect(() => {
        // Authentication succeeded and the tenant is known by our system
        if (!meLoading && isAuthenticated && known) {
            history.push(returnUrl);
        }
    }, [meLoading, isAuthenticated, known]);

    const handleLoginClick = () => {
        // Redirect to the login page when the button is clicked
        history.push(`/login/?returnUrl=${returnUrl}`);
    };

    const handleLogOut = () => {
        setLoginProgrees(true)
        instance.logoutRedirect()
    };

    return (
        <div className='callback'>
            <NavigationBar/>
            <div className='container'>
                {
                    inProgress.toString() !== 'none' || meLoading ? <Spinner size={SpinnerSize.large}/> : null
                }
                {
                    isAuthenticated &&
                    account?.name !== undefined &&
                    account?.username !== undefined && !known && !meLoading ?
                        <CallbackLoggedInNotKnow name={account.name} email={account.username}
                                                 handleLogout={handleLogOut}/> : null
                }
                {
                    loginProgrees ?
                        <div className='popupContainer'>
                            <h3>U bent niet ingelogd.</h3>
                            <p>Klik on de knop "Inloggen" om toegang te krijgen tot ProcurementHub.</p>
                            <DefaultButton primary onClick={handleLoginClick} text="Inloggen"/>
                        </div> : null
                }
            </div>
        </div>
    );
};


export default Callback;
